export default "19c0052995898f6c.svg"